import './App.css';
import MyApp from "./component/App";
import "swiper/css";
import "swiper/css/pagination";
import "zmp-ui/zaui.css";
import "./css/app.scss";

function App() {
  return (
    <div className="App">
      <MyApp/>
    </div>
  );
}

export default App;
